import { deepCompareEQ, deepClone } from '@cf-shared/deep-helpers';

export class ChangeChecker {
  object: any;
  groundTruth: any = {};

  constructor(o: any) {
    this.object = o;
    this.markSaved();
  }

  hasChanged(): boolean {
    return !deepCompareEQ(this.groundTruth, this.object);
  }

  markSaved() {
    this.groundTruth = deepClone(this.object);
  }
}
